import { CssBaseline, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from './theme';

const AppThemeProvider = ({ children }) => {
  const currentTheme = useSelector((state) => state.ui.theme);

  const theme = useMemo(() => {
    return currentTheme === 'dark' ? darkTheme : lightTheme;
  }, [currentTheme]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppThemeProvider;
